import React, { Component } from "react";
import Link from 'gatsby-link';

class Menu extends Component {
  render() {
    var visibility = "hide";

    if (this.props.menuVisibility) {
      visibility = "show";
    }

    return (

          <div id="flyoutMenu"
               className={visibility}>
               <div className="menu">
                   <div className="menu__wrapper">

                       <div className="menu__close" onMouseDown={this.props.handleMouseDown}><span>Close</span></div>

               <div className="menu__about">
                  Workplaces is an ad-less un-sponsored look at business and culture. Suspendisse non lectus sed magna euismod porta vel id lorem. Vivamus ultrices sollicitudin diam vitae porta.
               </div>
               <div className="menu__links">
                   <a className="c-green" href="https://underdog.io/" target="_blank">Underdog.io</a>
               </div>
          </div>
        </div>
    </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.jsx